import { Box, styled, Typography } from "@mui/material"

import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"

import {
  ContentContainer,
  TitleContainer,
  InfoTextCurrency,
  MasterFieldTimeTitle,
  AmountTitle,
  InfoTextOverflow,
} from "./styled"
import { OperationHistoryItemProps } from "./props"
import { RUBLE } from "../../utils/constants"

import { setOperation } from "../../store/slices/operationsHistorySlice"
import {
  getOperationDirection,
  getOperationIcon,
  getOperationMasterField,
  getOperationTitle,
} from "../../utils/operation"
import { extractTime } from "../../utils/datetime"
import { formatAmount } from "../../utils/formatters"

const OperationHistoryItem = ({ operation }: OperationHistoryItemProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClick = () => {
    const path = operation.operationId
    dispatch(setOperation(operation))
    navigate(path)
  }

  const OperationIconStyled = styled(getOperationIcon(operation))({})

  const masterField = getOperationMasterField(operation)

  return (
    <Box sx={ContentContainer} onClick={() => handleClick()}>
      <OperationIconStyled />
      <Box sx={TitleContainer}>
        <Box sx={InfoTextCurrency}>
          <Typography
            variant="h2"
            sx={{
              ...InfoTextOverflow,
              transform: masterField ? "translateY(0)" : "translateY(12px)",
            }}
          >
            {getOperationTitle(operation)}
          </Typography>
          <Typography sx={AmountTitle} variant="h2">
            {getOperationDirection(operation)}
            {formatAmount(operation.amount)} {RUBLE}
          </Typography>
        </Box>
        <Box sx={MasterFieldTimeTitle}>
          <Typography variant="h3">{masterField}</Typography>
          <Typography variant="h3">
            {extractTime(operation.updatedOn)}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
export default OperationHistoryItem
